<template>
  <section class="contributors">
    <h3 class="contributors__title content__title content__title--contrast" v-html="content.data.contributors.header">
    </h3>
    <div class="contributors__intro content__text" v-html="content.data.contributors.intro">
    </div>
    <div class="contributors__container">
      <div class="contributors__item" v-for="item in content.data.contributors.people"
      :key="item.name">
   <img
          class="contributors__img "
          v-bind:src="`https://api.rewolucyjna.pl/cms/${item.img}`"
          :alt="item.name"
        /> 

        <div class="contributors__name" v-html="item.name"></div>
        <div class="contributors__desc" v-html="item.desc">
        </div>
      </div>
    </div>
     <div class="content__text" v-html="content.data.contributors.content">
    </div>
  </section>
</template>

<script>
export default {
  name: "Contributors",
  inject: ['content'],
};
</script>
